var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Model, Emit, Prop } from 'vue-property-decorator';
import { Getter } from "vuex-class";
var SelectDepartment = /** @class */ (function (_super) {
    __extends(SelectDepartment, _super);
    function SelectDepartment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectDepartment.prototype.emitDeptId = function (id, code) { };
    Object.defineProperty(SelectDepartment.prototype, "deptIds", {
        get: function () {
            if (!this.deptId)
                return [];
            return this.getAllParentId(this.deptId, this.deptType);
        },
        set: function (val) {
            var id = "";
            var code = "";
            if (val.length) {
                id = val[val.length - 1];
                code = this.getDeptCodeById(id);
            }
            this.emitDeptId(id, code);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectDepartment.prototype, "options", {
        get: function () {
            return this.departmentTreeData(this.deptType);
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Getter
    ], SelectDepartment.prototype, "departmentTreeData", void 0);
    __decorate([
        Getter
    ], SelectDepartment.prototype, "getAllParentId", void 0);
    __decorate([
        Getter
    ], SelectDepartment.prototype, "getDeptCodeById", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], SelectDepartment.prototype, "changeOnSelect", void 0);
    __decorate([
        Prop({
            type: String
        })
    ], SelectDepartment.prototype, "deptType", void 0);
    __decorate([
        Model("on-select-change")
    ], SelectDepartment.prototype, "deptId", void 0);
    __decorate([
        Emit("on-select-change")
    ], SelectDepartment.prototype, "emitDeptId", null);
    SelectDepartment = __decorate([
        Component({})
    ], SelectDepartment);
    return SelectDepartment;
}(Vue));
export default SelectDepartment;
